import { Button } from "@/components/ui/button";
import { Loader2, X } from "lucide-react";

interface Props {
  selectedText: string;
  explanation: string;
  isLoading: boolean;
  onDismiss: () => void;
}

export function ExplanationCard({
  selectedText,
  explanation,
  isLoading,
  onDismiss,
}: Props) {
  return (
    <div
      className="mx-2 mb-2 rounded-md border bg-muted/50 p-3"
      data-testid="explanation-card"
    >
      <div className="mb-2 flex items-start justify-between gap-2">
        <p className="text-xs font-medium text-muted-foreground">Explanation</p>
        <Button
          variant="ghost"
          size="xs"
          onClick={onDismiss}
          aria-label="Dismiss explanation"
        >
          <X className="size-3" />
        </Button>
      </div>
      <blockquote className="mb-2 border-l-2 pl-2 text-xs italic text-muted-foreground">
        {selectedText.length > 200
          ? selectedText.slice(0, 200) + "..."
          : selectedText}
      </blockquote>
      {isLoading ? (
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Loader2 className="size-3 animate-spin" />
          Generating explanation...
        </div>
      ) : (
        <p className="text-xs leading-relaxed">{explanation}</p>
      )}
    </div>
  );
}
